import React, { useState } from 'react';
import {
  Box,
  Button,
  Typography,
  TextField,
  InputAdornment,
  IconButton,
} from '@mui/material';
import { ConfirmDialog } from '../common';
import {
  Delete as DeleteIcon,
} from '@mui/icons-material';

interface GridSizeControlsProps {
  tempRow: number;
  tempColumn: number;
  onTempRowChange: (value: number) => void;
  onTempColumnChange: (value: number) => void;
  onApplyGridSize: () => void;
  onClearAll: () => void;
}

export const GridSizeControls: React.FC<GridSizeControlsProps> = ({
  tempRow,
  tempColumn,
  onTempRowChange,
  onTempColumnChange,
  onApplyGridSize,
  onClearAll,
}) => {
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);

  const handleDeleteClick = () => {
    setOpenConfirmDialog(true);
  };

  const handleConfirmDelete = () => {
    onClearAll();
    setOpenConfirmDialog(false);
  };

  const handleCancelDelete = () => {
    setOpenConfirmDialog(false);
  };

  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant="h6" sx={{ fontSize: '16px', fontWeight: 600, mb: 2 }}>
        ページ設定
      </Typography>
      <Box display="flex" justifyContent="space-between" alignItems="center">
      <Box display="flex" gap={2} alignItems="center">
        <Box>
          <TextField
            type="number"
            value={tempRow}
            onChange={(e) => onTempRowChange(parseInt(e.target.value) || 1)}
            inputProps={{ min: 1 }}
            placeholder="行:"
            sx={{ 
              width: 160,
              '& .MuiOutlinedInput-root': {
                backgroundColor: '#FFFFFF',
                borderRadius: '16px',
                height: '48px',
                '& fieldset': {
                  borderColor: '#D0D0D0',
                },
                '& input[type=number]': {
                  MozAppearance: 'textfield',
                  textAlign: 'right',
                  '&::-webkit-inner-spin-button': {
                    opacity: 1,
                    WebkitAppearance: 'inner-spin-button',
                    marginLeft: '12px',
                  },
                  '&::-webkit-outer-spin-button': {
                    opacity: 1,
                  },
                },
              },
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Typography variant="body2" sx={{ fontSize: '14px', color: '#666666' }}>
                    行:
                  </Typography>
                </InputAdornment>
              ),
            }}
          />
        </Box>
        
        <Box>
          <TextField
            type="number"
            value={tempColumn}
            onChange={(e) => onTempColumnChange(parseInt(e.target.value) || 1)}
            inputProps={{ min: 1 }}
            placeholder="列:"
            sx={{ 
              width: 160,
              '& .MuiOutlinedInput-root': {
                backgroundColor: '#FFFFFF',
                borderRadius: '16px',
                height: '48px',
                '& fieldset': {
                  borderColor: '#D0D0D0',
                },
                '& input[type=number]': {
                  MozAppearance: 'textfield',
                  textAlign: 'right',
                  '&::-webkit-inner-spin-button': {
                    opacity: 1,
                    WebkitAppearance: 'inner-spin-button',
                    marginLeft: '12px',
                  },
                  '&::-webkit-outer-spin-button': {
                    opacity: 1,
                  },
                },
              },
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Typography variant="body2" sx={{ fontSize: '14px', color: '#666666' }}>
                    列:
                  </Typography>
                </InputAdornment>
              ),
            }}
          />
        </Box>
        
        <Button 
          variant="contained"
          sx={{
            backgroundColor: '#1B76D2',
            color: '#FFFFFF',
            height: '48px',
            borderRadius: '16px',
            px: 3,
            fontSize: '14px',
            '&:hover': {
              backgroundColor: '#1565C0',
            },
          }}
          onClick={onApplyGridSize}
        >
          適用
        </Button>
        </Box>
        
        <IconButton
          onClick={handleDeleteClick}
          sx={{
            backgroundColor: '#FFFFFF',
            border: '1px dashed #F44336',
            width: 40,
            height: 40,
            padding: 0,
            borderRadius: '8px',
            '&:hover': {
              backgroundColor: '#FFFFFF',
            },
          }}
        >
          <img 
            src="/assets/images/trash.svg" 
            alt="削除" 
            style={{ width: '20px', height: '20px', filter: 'none' }}
          />
        </IconButton>
      </Box>

      {/* 削除確認ダイアログ */}
      <ConfirmDialog
        open={openConfirmDialog}
        onClose={handleCancelDelete}
        onConfirm={handleConfirmDelete}
        message="削除します。よろしいですか？"
        confirmText="削除"
        confirmColor="#DB2323"
        confirmHoverColor="#C01F1F"
      />
    </Box>
  );
};

